import { Box, Flex, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import ZaraButton from '../../components/custom-components/buttons/Button';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../router/routes';

const PageNotFound = () => {
    const router = useNavigate();

    const isAuth = localStorage.getItem('token') || sessionStorage.getItem('token');

    const backPath = () => {
        if (isAuth) {
            router(PATHS.MY_AGENT);
        } else {
            router(PATHS.SIGN_IN);
        }
    };

    return (
        <Box>
            <Heading margin='20px 0px' textAlign='center' size='4xl'>
                404
            </Heading>
            <Text m='20px 0px' textAlign='center' fontSize='20px' fontWeight='400' lineHeight='40px' color='#4A5568'>
                Oops, an error has occured. Page not found!
            </Text>
            <Flex justifyContent='center'>
                <ZaraButton w='200px' onClick={backPath}>
                    {isAuth ? 'Go to Dashboard' : 'Go to Sign-in'}
                </ZaraButton>
            </Flex>
        </Box>
    );
};

export default PageNotFound;
